export default __webpack_public_path__ + "124a965ffc59a680c2c20c69c2984032.ttf";